//custom js
jQuery(function($){
  var locationData = JSON.parse($('#locationMenuJSON').html());
  $(document).on('click', '.region-selector', function(){
    var region = $(this).data('value');
    var optionsHtml = '';
    var firstStoreUrl = false;
    var initialVal = $(this).parents('.selector-wrapper').siblings('.selector-wrapper').find('.editable-select').data('initial-value');
    var count = 0;
    $(this).parent().siblings('input').val(region);
    $.each(locationData[region], function(index, value){
      count += 1;
      var selected_string = "";
      var initial_value = value[0];
      if(Object.keys(locationData[region]).length > 1) initial_value = initialVal.toUpperCase();
      if(count == 1) {
        firstStoreUrl = value[1];
        if(Object.keys(locationData[region]).length > 1) firstStoreUrl = '#';
        $('.store-selector').parent().siblings('input').val(initial_value);
        //selected_string = " selected";
      }
      optionsHtml += '<li class="store-selector" data-value="'+index+'"'+selected_string+'>'+value[0]+'</li>';
    });
    $('.store-selector').parent().html(optionsHtml);
    $('.store-button').attr('href', firstStoreUrl);
    $(this).parent().hide();
  });
  $(document).on('click', '.store-selector', function(){
    var region = $('.region-selector-input').val();
    var store = $(this).data('value');
    var storeUrl = locationData[region][store][1];
    $(this).parent().siblings('input').val(store);
    $('.store-button').attr('href', storeUrl);
    $(this).parent().hide();
  });
  $(document).on('click', 'input.select-input', function(){
    $(this).next().find('li').show();
    $(this).next().toggle();
    $(this).parents('.selector-wrapper').siblings('.selector-wrapper').find('.editable-select').hide();
  });
  $(document).on('keyup', 'input.select-input', function(){
    var subString = $(this).val().toLowerCase();
    $(this).next().find('li').each(function(){
      if($(this).data('value').toLowerCase().indexOf(subString) > -1){
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
   $(document).on('mouseleave', '.editable-select', function(){
     $('.editable-select').hide();
   });
  $(document).on('click', '.location-area a[href="#"]', function(e){
    e.preventDefault();
    alert($('.store-selector-input').siblings('ul').data('initial-value'));
  });
  
  // Script para que seleccione ciudade spor tipo de tienda
  var store_type = "";
  
  $("#type-1").prop("checked", true);
  $('.region-selector-input').val('Seleccione Ciudad');
  $('.store-selector-wrapper').hide();
  $('#btn-reload').hide();
  
  
  setTimeout(function(){ 
    $('.region-selector-wrapper .editable-select-area ul li').each(function(){
      //if($(this).text().indexOf("Cl.") >= 0 ){ $(this).addClass('hide-important');}
      //if($(this).text().indexOf("C.O.") >= 0 ){ $(this).addClass('hide-important');}
    });
    
  }, 1000);
  
  
  $("input[name='store-type']").click(function(){
  	store_type = $(this).val();
    $('.region-selector-input').val('Seleccione Ciudad');
    $('.store-selector-wrapper').hide();
  	$('#btn-reload').hide();
    
    if($(this).val() == 'type-1'){
      $('.region-selector-wrapper .editable-select-area ul li').addClass('hide-important');
      $('.region-selector-wrapper .editable-select-area ul li').click(function(){setTimeout(function(){$('.store-selector-wrapper ul.editable-select li').removeClass('hide-important'); },500);}); //Reset Tiendas

      $('.region-selector-wrapper .editable-select-area ul li').each(function(){
        if($(this).text().indexOf("Cl.") >= 0 ){ $(this).addClass('hide-important');}else if($(this).text().indexOf("C.O.") >= 0 ){ $(this).addClass('hide-important');}else{$(this).removeClass('hide-important');}
      	//$(this).removeClass('hide-important');
      });
    }
    
    if($(this).val() == 'type-2'){
      $('.region-selector-wrapper .editable-select-area ul li').addClass('hide-important');
      $('.region-selector-wrapper .editable-select-area ul li').click(function(){setTimeout(function(){$('.store-selector-wrapper ul.editable-select li').removeClass('hide-important'); },500);}); //Reset Tiendas

      //Clínica Bogotá
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Bogotá"]').removeClass('hide-important');
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Bogotá"]').click(function(){
        setTimeout(function(){
       	  $('.store-selector-wrapper .editable-select-area ul li').each(function(){
              if($(this).text().indexOf('Clínica') !== -1 ){ $(this).removeClass('hide-important');}else{$(this).addClass('hide-important');}
          });
        },500);
      });
	  
      //Clínica Barranquilla
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Barranquilla"]').removeClass('hide-important');
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Barranquilla"]').click(function(){
        setTimeout(function(){
       	  $('.store-selector-wrapper .editable-select-area ul li').each(function(){
              if($(this).text().indexOf('Clínica') !== -1 ){ $(this).removeClass('hide-important');}else{$(this).addClass('hide-important');}
          });
        },500);
      });

	  //Clínica Cali
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Cali"]').removeClass('hide-important');
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Cali"]').click(function(){
        setTimeout(function(){
       	  $('.store-selector-wrapper .editable-select-area ul li').each(function(){
              if($(this).text().indexOf('Clínica') !== -1 ){ $(this).removeClass('hide-important');}else{$(this).addClass('hide-important');}
          });
        },500);
      });
    }
    
    if($(this).val() == 'type-3'){
      $('.region-selector-wrapper .editable-select-area ul li').addClass('hide-important');
      $('.region-selector-wrapper .editable-select-area ul li').click(function(){setTimeout(function(){$('.store-selector-wrapper ul.editable-select li').removeClass('hide-important'); },500);}); //Reset Tiendas
      
      //CO Bogotá
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Bogotá"]').removeClass('hide-important');
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Bogotá"]').click(function(){
        setTimeout(function(){
       	  $('.store-selector-wrapper .editable-select-area ul li').each(function(){
              if($(this).text().indexOf('Oftalmológico') !== -1 ){ $(this).removeClass('hide-important');}else{$(this).addClass('hide-important');}
          });
        },500);
      });
      
      //CO Medellín
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Medellín"]').removeClass('hide-important');
      $('.region-selector-wrapper .editable-select-area ul li[data-value="Medellín"]').click(function(){
        setTimeout(function(){
       	  $('.store-selector-wrapper .editable-select-area ul li').each(function(){
              if($(this).text().indexOf('Oftalmológico') !== -1 ){ $(this).removeClass('hide-important');}else{$(this).addClass('hide-important');}
          });
        },500);
      });
      
       
//       $('.region-selector-wrapper .editable-select-area ul li').each(function(){
//         if($(this).text().indexOf("C.O.") >= 0 ){ $(this).removeClass('hide-important');}else{$(this).addClass('hide-important');}
//       });
    }
    
  });
  
  
  $('.region-selector-wrapper .editable-select-area ul li').click(function(){
  	$('.store-selector-wrapper').show();
    $('#btn-reload').show();
  });
  
  
  
  
  
  
  
  
});